module.exports = __webpack_public_path__ + "static/media/logo-mobile.2054c76d.jpg";